import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bookmark",
  "use": "bookmark-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"bookmark\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M15 3.8H5a.2.2 0 0 0-.2.2v11.996a.2.2 0 0 0 .333.15l3.668-3.276a1.8 1.8 0 0 1 2.398 0l3.668 3.275a.2.2 0 0 0 .333-.149V4a.2.2 0 0 0-.2-.2ZM5 3h10a1 1 0 0 1 1 1v11.996c0 .864-1.022 1.322-1.666.746l-3.668-3.275a1 1 0 0 0-1.332 0l-3.668 3.275C5.022 17.318 4 16.86 4 15.996V4a1 1 0 0 1 1-1Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol